/**
 * Shared wording and formatting for an AI Service's stop state (task 1164).
 *
 * Report: `project/reports/innovate-service-endpoint-stop-and-circuit-breaker.md`.
 * Design: `project/artifacts/innovate-app-service-stop-circuit-breaker-mockup.html`.
 */

/** "Oct 14, 2026 at 14:02" in the viewer's own locale and zone. */
export const formatStopInstant = (instant: string): string => {
  const date = new Date(instant);
  const day = date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
  const time = date.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
  return `${day} at ${time}`;
};

/** What a stop with no reason shows, in the banner and in the history. */
export const NO_STOP_REASON = 'no reason given';

/**
 * The tooltip on a Schedule row's disabled Resume while the service is stopped.
 * The service is started, a Schedule is resumed (task 1191). (The pause detail
 * itself reads through `scheduleStatusDetailText`.)
 */
export const RESUME_SERVICE_FIRST = 'Start the AI Service first';
